import React from "react";
import { Box } from "@mui/material";
import DynamicTableForJson from "../../data/DynamicTable/dynamicTableForJson";
import { customerservice } from "../../config";

const base_url = customerservice.uri;

const CustomerLoanLimitApprovalTableRO = () => {
  const params = {
    // isApproved: false,
    iscompanyapproval: 0,
    isregionapproval: 0,
    isbranchapproval: 0,
    isfieldofficerapproval: 1,

    
  };
  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    approveLoanLimit: {
      key: "APPROVELOANLIMIT",
      button_name: "ApproveloanLimit",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: "param", // Specify the model name here
      inputObjectName: "approveRejectLoanLimit",
      flag: 1,
    },
    rejectLoanLimitUpdate: {
      key: "REJECTLOANLIMIT",
      button_name: "RejectloanLimit",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: "param", // Specify the model name here
      inputObjectName: "approveRejectLoanLimit",
      flag: 2,
    },
    dataObject: {
      ignoreFields: [
        "CreateDate",
        "UpdateDate",
        "IsActive",
        "DateApproved",
        "AmountBeforeUpdate",
        "InitiatedDate",
      ],
      objectName: "loanLimit",
      parameters: params,
      inputObjectName: "loanlimit",
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Approve Customer Loan Limit Relationship Officer"
        subtitle="Approve Loan limit"
        // FormComponent={SuspendedTransactionForm}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default CustomerLoanLimitApprovalTableRO;
